import React from 'react';
import { CellProps, WithClassname } from '@jsonforms/core';
import { Switch } from 'antd';
import merge from 'lodash/merge';

export const AntdToggle = React.memo((props: CellProps & WithClassname) => {
  const { data, enabled, uischema, path, handleChange, config } = props;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);
  const checked = !!data;

  return (
    <div className='flex w-full justify-end border-b border-brightGray px-1.5 py-4'>
      <Switch
        checked={checked}
        onChange={isChecked => handleChange(path, isChecked)}
        disabled={!enabled}
        autoFocus={!!appliedUiSchemaOptions.focus}
      />
    </div>
  );
});
